import {
    Component,
    forwardRef,
    inject,
    Input,
    OnInit,
    ChangeDetectionStrategy
} from "@angular/core";
import { takeUntil } from "rxjs/operators";
import { ValidationMessageRowComponent } from "../../../../../validation/validation-message-row/validation-message-row.component";
import { ButtonComponent } from "../../../../button/button.component";
import { IMapComponent } from "../../../map.models";
import { IMapSettings } from "../../../map.settings";
import { MapSelectService } from "../../../services/map-select.service";
import { MapBaseSubComponent } from "../map-base-sub-component/map-base-sub.component";

@Component({
    selector: "rask-map-select",
    templateUrl: "./map-select.component.html",
    styleUrls: ["./map-select.component.scss"],
    providers: [
        {
            provide: MapBaseSubComponent,
            useExisting: forwardRef(() => MapSelectComponent)
        },
        MapSelectService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ValidationMessageRowComponent,
        ButtonComponent
    ]
})
export class MapSelectComponent extends MapBaseSubComponent implements OnInit {

    @Input() geotypes = "geometrier";
    @Input() hidden = false;
    mapsettings: IMapSettings;
    arcView: any;
    map: IMapComponent;
    widgetId = "map-select";
    buttons = [
        {
            iconClass: "fa-lasso",
            tooltipText: "Markera",
            visible: () => !this.hidden && this.selectService.canSelect(),
            disabled: this.disabled,
            widgetId: this.widgetId
        },
        {
            iconClass: "fa-slash fa-flip-horizontal",
            iconClassStacked: "fa-lasso",
            tooltipText: "Avmarkera",
            visible: () => this.selectService.hasSelection(),
            disabled: this.disabled,
            widgetId: "map-deselect",
            click: () => {
                this.selectService.removeAllSelections();
            }
        },
        {
            iconClass: "fa-object-group",
            tooltipText: "Panorera till valda",
            visible: () => this.selectService.hasSelection(),
            disabled: this.disabled,
            widgetId: "map-zoom-selected",
            click: () => {
                const sel = this.selectService.getSelected();
                if (sel?.length > 0) {
                    this.map.gotoGeometries(sel);
                }
            }
        }
    ];

    private readonly selectService = inject(MapSelectService);

    preInit(mapsettings: IMapSettings) {
        this.mapsettings = mapsettings;
    }

    onInit(arcView, arcDraw) {
        this.arcView = arcView;
        this.selectService.init(this.mapsettings, this.arcView, null, null);
    }

    ngOnInit(): void {
        this.mapReady.pipe(
            takeUntil(this.destroy$)
        ).subscribe(instance => {
            this.map = instance;
        });

        this.onShow.pipe(
            takeUntil(this.destroy$)
        ).subscribe(() => {
            this.startSelect();
        });

        this.onHide.pipe(
            takeUntil(this.destroy$)
        ).subscribe(() => {
            this.stopSelect();
        });
    }

    isSelecting() {
        return this.selectService.isReady() && this.selectService.isSelecting;
    }

    startSelect() {
        if (this.selectService.isReady()) {
            this.selectService.startLassoSelect(() => {
                this.stopSelect();
            });
        }
    }

    stopSelect() {
        this.selectService.stopLassoSelect();
        this.map?.closeWidgets();
    }
}
